import React from "react";

import { twMerge } from "tailwind-merge";

import * as styles from "./styles";

export function Slider({
  isOpen = false,
  className,
  children,
}: {
  isOpen?: boolean;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={twMerge(styles.container, className)}
      data-testid="slider"
      data-is-open={isOpen}
    >
      {children}
    </div>
  );
}
